import React, { useState } from 'react';
import personCenter from 'asset/img/personCenter.webp';
import rank from 'asset/img/rank.png';
import smile from 'asset/img/control-person.png';
import record from 'asset/img/control-record.png';
import pet from 'asset/img/pet.png';
import './index.scss'
import { useNavigate } from 'react-router-dom';

const ControlCenter = ({ onVisibilityChange }) => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = (e) => {
        e.stopPropagation();
        const next = !isVisible;
        setIsVisible(next);
        onVisibilityChange?.(next);
    };

    const closeMenu = () => {
        setIsVisible(false);
        onVisibilityChange?.(false);
    };

    let navigate = useNavigate();
    const goto = (path) => {
        navigate(path);
    }
    const content = [
        {
            name: '排行榜', path: '/rank', icon: rank
        },
        {
            name: '个人中心', path: '/personCenter', icon: smile
        },
        {
            name: '学习记录', path: '/record', icon: record
        },
        {
            name: '大圣庄园', path: '/pet', icon: pet
        }
    ]

    return (
        <>
            {/* 点击空白处关闭的遮罩层 */}
            {isVisible && <div className='controlCenter-overlay' onClick={closeMenu} />}
            
            <div className='controlCenter-container' onClick={toggleVisibility}>
                <div className={`controlCenter-content ${isVisible ? 'visible' : ''}`}>
                    {content.map((item, index) => {
                        return <div className='controlCenter-item' key={index} onClick={(e) => e.stopPropagation()}>
                            <div className='icon' onClick={() => goto(item.path)}><img src={item.icon} alt="" /></div>
                            <div className='title'>{item.name}</div>
                        </div>
                    })}

                </div>
                <img src={personCenter} />
            </div>
        </>
    );
};

export default ControlCenter;
